import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faLink } from "@fortawesome/free-solid-svg-icons"

export const Link = (props) => {
  return <FontAwesomeIcon faIcon={faLink} {...props} />
}
